export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/ping.worker.790e4482.worker.js");
}
